import watchGetSubscriptions from './getSubscriptions';
import watchGetAccounts from './getAccounts';

const watchSubscriptions = [watchGetSubscriptions, watchGetAccounts];

export default watchSubscriptions;
